function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#2A5ADA"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 5l-1.27.739L7.27 7.76 6 8.5v7l1.27.738 3.492 2.024 1.27.738 1.27-.738 3.428-2.024L18 15.5v-7l-1.27-.739-3.46-2.022L12 5zm-3.46 9.023V9.977L12 7.954l3.46 2.023v4.046L12 16.046l-3.46-2.023z",
  fill: "#fff"
});

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "f65cbe2c6d61e709211f8b5765f6d742.svg";
export { SvgLink as ReactComponent };